import { z } from "zod";
export const VenusStartupRoleSchema = z.object({
    phase: z.enum([
        "waiting",
        "allocated",
        "loading",
        "ready",
        "failed",
        "unknown",
    ]),
    hardware: z
        .object({
        gpuName: z.string().trim().min(1).max(120).nullable(),
        country: z.string().trim().min(1).max(80).nullable(),
        location: z
            .object({
            city: z.string().max(120),
            country: z.string().min(1).max(80),
            latitude: z.number().finite().min(-90).max(90),
            longitude: z.number().finite().min(-180).max(180),
            precision: z.enum(["region", "facility"]),
        })
            .nullable()
            .optional(),
    })
        .nullable()
        .optional(),
    observedAt: z.string().datetime(),
    memory: z
        .object({
        usedMiB: z.number().finite().nonnegative(),
        totalMiB: z.number().finite().positive(),
    })
        .refine((value) => value.usedMiB <= value.totalMiB)
        .nullable(),
});
export const VenusStartupSchema = z.object({
    contract: z.literal("mlx.venus.startup.v1"),
    parent: VenusStartupRoleSchema,
    explorer: VenusStartupRoleSchema.nullable(),
});
export const VENUS_ALLOCATION_WAIT_MS = 60_000;
export function venusStartupDecision(status, deepSpace, elapsedMs) {
    if (status.parent.phase === "ready" &&
        (!deepSpace || status.explorer?.phase === "ready"))
        return "ready";
    if (elapsedMs < VENUS_ALLOCATION_WAIT_MS)
        return "wait";
    if (status.parent.phase !== "allocated" &&
        status.parent.phase !== "loading" &&
        status.parent.phase !== "ready")
        return "external";
    if (deepSpace &&
        status.explorer?.phase !== "allocated" &&
        status.explorer?.phase !== "loading" &&
        status.explorer?.phase !== "ready")
        return "venus";
    return "wait";
}
